import {FormEvent, useState} from "react";

type GenericObject = Record<string | number | symbol, any>;

export interface ReturnValues {
    inputs: GenericObject;
    handleChange: (e: FormEvent) => void;
    reset: () => void;
}

const useInputs = (initialValues: GenericObject): ReturnValues => {
    const [inputs, setInputs] = useState(initialValues);

    return {
        inputs,
        handleChange: e => {
            const {name, value} = e.target as HTMLInputElement;

            setInputs({
                ...inputs,
                [name]: value,
            });
        },
        reset: () => setInputs(initialValues),
    };
};

export default useInputs;
